import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Button, Space, Typography, Grid } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';

const { Text } = Typography;
const { useBreakpoint } = Grid;

const NoteTemplatesList = ({ 
  templates, 
  onEdit, 
  onDelete 
}) => {
  const { t } = useTranslation();
  const screens = useBreakpoint();

  return (
    <Space direction="vertical" style={{ width: "100%" }} size="middle">
        {templates.map((template) => (
          <Card 
            key={template.getUUID()}
            style={{ 
              backgroundColor: '#fafafa',
              border: "1px solid #e8e8e8",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
            hoverable
            onClick={() => onEdit(template)}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ flex: 1, marginRight: "12px" }}>
                <Text style={{ fontSize: '15px', fontWeight: '500', display: 'block', marginBottom: '8px' }}>
                  {template.getName()}
                </Text>
                {screens.md && (
                  <Text 
                    style={{ 
                      fontSize: '14px', 
                      color: 'rgba(0, 0, 0, 0.65)', 
                      fontStyle: 'italic',
                      display: 'block'
                    }}
                  >
                    {template.getContent() ? 
                      (template.getContent().length > 100 ? 
                        template.getContent().substring(0, 100) + '...' : 
                        template.getContent()
                      ) : 
                      t('note_templates.no_content')
                    }
                  </Text>
                )}
              </div>
              <Space size="small">
                <Button
                  type="text"
                  icon={<EditOutlined />}
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent card click when clicking edit button
                    onEdit(template);
                  }}
                  size="small"
                />
                <Button
                  type="text"
                  icon={<DeleteOutlined />}
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent card click when clicking delete button
                    onDelete(template.getUUID());
                  }}
                  size="small"
                />
              </Space>
            </div>
          </Card>
        ))}
      </Space>
  );
};

export default NoteTemplatesList;
